import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {UntypedFormGroup} from "@angular/forms";
import {MatRadioChange} from "@angular/material/radio";
import {MatCheckboxChange} from "@angular/material/checkbox";
import {MatSlideToggleChange} from "@angular/material/slide-toggle";

@Component({
  selector: 'app-moderat-sanierung-measure',
  templateUrl: './sanierung-measure.component.html'
})
export class SanierungMeasureComponent implements OnInit, OnChanges {

  /**
   * Name of the measure we want to display here
   */
  @Input() measure: string;

  /**
   * amount of the saving (energy or co2)
   */
  @Input() saving: number;

  /**
   * The maximum saving to calculate the with of the bars
   */
  @Input() maxSaving: number;

  /**
   * unit of the saving
   */
  @Input() savingUnit: string;

  /**
   * formgroup holding teh formelements of all measures
   */
  @Input() form: UntypedFormGroup;

  /**
   * name of the current formfield
   */
  @Input() formField: string;

  /**
   * bool value if portal is internal
   */
  @Input() internalPortal: boolean;

  /**
   * the current value, optional. If not set the vcalue of the formfield is used
   */
  @Input() value: string = null;

  /**
   * toggle if this measure is recommend or not
   */
  @Input() recommend: string = null;

  /**
   * prefix for all used textkeys
   */
  @Input() textPrefix: string = 'moderat.sanierung.massnahmen.';

  /**
   * extra postfix for some texts
   */
  @Input() textPostfix: string = '';

  /**
   * input type. One of checkbox|radio|switch
   */
  @Input() inputType: string = 'checkbox';

  /**
   * Event emitter for toggling text.
   *
   * @type {EventEmitter<void>}
   */
  @Output() onToggleText: EventEmitter<void> = new EventEmitter<void>();

  /**
   * toggle for the extra text of the measure
   */
  showText: boolean = false;

  /**
   * width of the bar as style string
   */
  width: string = 'auto';

  /**
   * show hint or not
   */
  hint: boolean = false;

  /**
   * toggle for showing an alert
   */
  alert: boolean = false;

  /**
   * toggle for the recommendation badge
   */
  showBadge: boolean = false;

  /**
   * @inheritDoc
   */
  ngOnInit(): void {
    this.updateWidth();

    this.updateHintStatusAndBadge();
  }

  /**
   * Toggles the value of 'showText' property and emits the 'onToggleText' event.
   *
   * @returns {void}
   */
  toggleShowText(): void {
    this.showText = !this.showText;
    this.onToggleText.emit();
  }

  /**
   * @inheritDoc
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges) {
    if(changes.hasOwnProperty('maxSaving') && changes.maxSaving.firstChange === false) {
      this.updateWidth();
    }
    if(changes.hasOwnProperty('recommend') && changes.recommend.firstChange === false) {
      this.updateHintStatusAndBadge();
    }
    if(changes.hasOwnProperty('saving') && changes.saving.firstChange === false) {
      this.updateWidth();
    }
  }

  /**
   * Update the badge status and the hint texts, based on the (changed) recommend status.
   */
  updateHintStatusAndBadge(): void {
    // set some local settings for the badge and hint texts
    this.alert = this.recommend === 'fossil';
    this.showBadge = this.recommend === 'empfehlung';
    this.hint = this.alert === false && this.showBadge === false && this.recommend !== '';
  }

  /**
   * UPdates the width of the bar, based on the maximum saving and the actual saving
   */
  updateWidth(): void {
    if(this.saving < 0) {
      this.width = Math.abs((this.saving / this.maxSaving) * 100) + "%";
    }
    else {
      this.width = 'auto';
    }
  }

  /**
   * Eventhandler if the selection of a measure is changed
   * @param event
   */
  changeMeasure(event: any) {
    if(event instanceof MatCheckboxChange || event instanceof MatSlideToggleChange) {
      this.form.get(this.formField).setValue(event.checked);
    }

    if(event instanceof MatRadioChange) {
      this.form.get(this.formField).setValue(event.value);
    }
  }

}
